/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import type { ReactNode } from "react";

import { ResponsiveContainer } from "../../../atoms/container/ResponsiveContainer.atom";
import { SectionContainer } from "../../../atoms/container/SectionContainer.atom";

export interface DirectorySectionProps {
	children: ReactNode;
}

/**
 * Canonical Directory section frame — `ResponsiveContainer + SectionContainer`
 * matching the rest of the Cosmos sections. Lift consumers off the primitive
 * atoms so the framing stays consistent if section spacing tokens are tuned
 * later.
 */
export function DirectorySection({ children }: DirectorySectionProps): React.JSX.Element {
	return (
		<ResponsiveContainer>
			<SectionContainer>{children}</SectionContainer>
		</ResponsiveContainer>
	);
}
